import { render, staticRenderFns } from "./BadgeStatusContract.vue?vue&type=template&id=513d7352&scoped=true&"
import script from "./BadgeStatusContract.vue?vue&type=script&lang=js&"
export * from "./BadgeStatusContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513d7352",
  null
  
)

export default component.exports
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QBadge});
